/* eslint-disable react/require-default-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import get from 'lodash/get';
import {
  Drawer, DrawerHeader, DrawerBody,
  IconButton,
  Typography
} from '@one-thd/sui-atomic-components';
import { Close } from '@one-thd/sui-icons';
import Markdown from '@gcc/pip-components/dist/Markdown';
import config from '../../config';
import dictionaryDefinitionApi from '../../api/dictionaryDefinitionApi';

function MeasuringTipsDrawer({ showDrawer, closeDrawer }) {
  const [dictionaryTerm, setDictionaryTerm] = useState('');

  useEffect(() => {
    const dictionaryDefinitionApiUrl = get(config(), 'loadDictionaryDefinitionApi');
    const productLineId = get(config(), 'productLineId');
    dictionaryDefinitionApi(dictionaryDefinitionApiUrl, 'Room', productLineId)
      .then((response) => { setDictionaryTerm(response.data.definition.Definition); });
  }, []);

  return (
    <>
      <Drawer open={showDrawer} onClose={closeDrawer} position="right">
        <DrawerHeader
          startAdornment={(<Typography variant="h4"> Measuring Tips </Typography>)}
          endAdornment={(
            <IconButton
              aria-label="Close Measuring Tips Drawer"
              data-testid="measuring-tip-close"
              icon={Close}
              onClick={closeDrawer}
            />
          )}
        />
        <DrawerBody>
          <Markdown source={dictionaryTerm} />
        </DrawerBody>

      </Drawer>
    </>
  );
}

MeasuringTipsDrawer.propTypes = {
  showDrawer: PropTypes.bool,
  closeDrawer: PropTypes.func,
};

MeasuringTipsDrawer.defaultProps = {
  showDrawer: false,
  closeDrawer: noop,
};

export default MeasuringTipsDrawer;
